import { useState } from "react"
import { useDispatch } from "react-redux"
import { deleteTimeOff, getCalendarBookings, getCalendarTimeOff } from "store/calendar"
import { toaster } from "components/common/Toast"

/**
 * Custom hook for handling time-off deletion logic
 * @param {Object} options - Configuration options
 * @param {Function} options.setEditingTimeOffItem - Function to clear editing item
 * @param {Object} options.form - Form instance to reset
 * @param {string} options.timeOffType - Type of time-off for refresh
 * @param {Object} options.dates - Dates for bookings refresh
 * @returns {Object} Deletion handlers and modal state
 */
export const useTimeOffDeletion = ({ setEditingTimeOffItem, form, timeOffType, dates, profileId }) => {
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false)
  const [deleteId, setDeleteId] = useState(null)
  const dispatch = useDispatch()

  const handleDeleteTimeOff = (id = null) => {
    setDeleteId(id)
    setIsDeleteModalOpen(true)
  }

  const handleCancelDeleteTimeOff = () => {
    setIsDeleteModalOpen(false)
    setDeleteId(null)
  }

  const handleYesDeleteTimeOff = () => {
    dispatch(deleteTimeOff(deleteId, profileId)).then((response) => {
      if (response?.message) {
        toaster.success(response.message)
      }
      setEditingTimeOffItem(null)
      form.resetFields()
      dispatch(getCalendarTimeOff({ ui_type: timeOffType }, profileId))
      dispatch(
        getCalendarBookings({
          "q[date_gteq]": dates?.start,
          "q[date_lteq]": dates?.end
        })
      )
      setIsDeleteModalOpen(false)
      setDeleteId(null)
    })
  }

  return {
    isDeleteModalOpen,
    handleDeleteTimeOff,
    handleCancelDeleteTimeOff,
    handleYesDeleteTimeOff
  }
}
